<template>
  <div class="bg-white relative">
    <div class="absolute close--container" :class="{ 'left--4': store.searchListVisible }">
      <zt-tooltip :text="tooltipContent" position="right" color="primary" outlined>
        <zt-button data-vs-button="search-colapse" gtm-class="zt-gtm-documents-search-colapse"
          @click="setSearchListVisible(!store.searchListVisible)" :icon="openIcon" class="close--list" fab outlined />
      </zt-tooltip>
    </div>
    <SearchInitialState v-if="store.initialStatus" />
    <template v-else-if="store.haveResults">
      <SearchTableHeader :downloadSelected="isDocumentsSelectedEmpty" @download-selected="downloadZip"
        :loader="loader" />
      <div class="search--table">
        <CustomTable :content="store.documents" :action="openPreview" @documents-selected="setDocumentsSelected" />
        <zt-modal :show-button-close="true" :active="previewPdf" @close="previewPdf = false" max-width="50vw"
          :title="$t('message.DocumentsComponents.previewDocument')">
          <div style="height: 80vh;">
            <iframe class="w-full h-full" id="blob"></iframe>
          </div>
        </zt-modal>
      </div>
      <SearchTableFooter />
    </template>
    <SearchEmptyResults v-else />
  </div>
</template>

<script>
import SearchInitialState from './SearchInitialState'
import SearchEmptyResults from './SearchEmptyResults'
import SearchTableHeader from './SearchTableHeader'
import CustomTable from './CustomTable'
import SearchTableFooter from './SearchTableFooter'
import { isEmpty } from 'lodash'
import Search from '@/apiClient/Search'
import Users from '@/apiClient/Users'
import { mapState } from 'vuex'

const setPdfUrl = pdf => {
  const url = URL.createObjectURL(pdf)
  document.querySelector('#blob').src = url
}

const b64toBlob = dataURI => {
  const byteString = atob(dataURI.split(',')[1])
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], { type: 'application/pdf' })
}

export default {
  name: 'SearchTable',
  inject: ['store', 'setSearchListVisible'],
  components: {
    SearchInitialState,
    SearchEmptyResults,
    CustomTable,
    SearchTableHeader,
    SearchTableFooter
  },
  data() {
    return {
      documentsSelected: [],
      searchConfig: new Search(),
      usersConfig: new Users(),
      previewPdf: false,
      loader: false
    }
  },
  computed: {
    ...mapState(['user']),
    openIcon() {
      return this.store.searchListVisible ? 'angle-left' : 'angle-right-solid'
    },
    tooltipContent() {
      return this.store.searchListVisible
        ? this.$t("message.workflow.hideFilters")
        : this.$t("message.workflow.showFilters")
    },
    isDocumentsSelectedEmpty() {
      return isEmpty(this.documentsSelected)
    }
  },
  methods: {
    setDocumentsSelected(event) {
      this.documentsSelected = event
    },
    async downloadZip() {
      try {
        this.loader = true
        const { data } = await this.searchConfig.DownloadZip(
          this.documentsSelected
        )

        const newBlob = new Blob([data], { type: 'application/octet-stream' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }
        const urlFile = window.URL.createObjectURL(newBlob)
        const link = document.createElement('a')
        link.href = urlFile
        link.download = 'Documentos' + Math.random() * 100 + '.zip'
        link.click()
        this.loader = false

        setTimeout(function () {
          window.URL.revokeObjectURL(urlFile)
        }, 100)
      } catch (error) {
        this.loader = false
      }
    },
    async openPreview({ documentId }) {
      try {
        const response = await this.usersConfig.showPdfDownload(
          this.user.aplicacion.id,
          documentId
        )

        this.previewRef = documentId

        const data_pdf_prefix = 'data:application/pdf;base64,'

        const pdfBlob = b64toBlob(data_pdf_prefix + response)

        this.previewPdf = true

        await this.$nextTick()

        setPdfUrl(pdfBlob)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.close--list {
  max-width: 28px !important;
  max-height: 28px !important;
}

.close--container {
  top: 25px;
}

.left--4 {
  left: -16px;
}

.search--table {
  max-height: calc(100vh - 74px - 70px - 141px);
  overflow-y: auto;
}
</style>
